import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { filterNavMenuItems, NAV_MENU_ITEMS } from '../config/navMenuConfig';

/**
 * Menú filtrado por permisos — única fuente para Rail, Flyout y drawer móvil.
 */
export default function useNavMenu() {
  const { currentUser, hasPermission, companyModules, permisosEfectivos } = useAuth();

  return useMemo(
    () => filterNavMenuItems({
      items: NAV_MENU_ITEMS,
      currentUser,
      hasPermission,
      companyModules,
      permisosEfectivos
    }),
    [currentUser, hasPermission, companyModules, permisosEfectivos]
  );
}
